import { useI18n } from "vue-i18n";
import { reportPdf, serverPdf, appStorage, AppStorageKey, AuditLogService, SERVER_PDF_ERROR, Store } from "app-core";
import { usePdfActions } from "./index44.js";
function useReportPdf(report, host) {
  const { t } = useI18n();
  let sent = null;
  return usePdfActions({
    available: () => serverPdf.supports("report"),
    offered: () => reportPdf.isOffered(report()),
    missingHint: () => report() ? void 0 : t("pdf.needs_report"),
    documentLine: () => {
      const shown = report();
      if (!shown) return "";
      const { title, period } = reportPdf.document(shown);
      return period ? `${title} · ${period}` : title;
    },
    defaultRecipient: async () => {
      var _a;
      const remembered = await appStorage.local().getItem(AppStorageKey.reportPdfRecipient);
      return remembered || ((_a = Store.get("tenant")) == null ? void 0 : _a.email) || "";
    },
    save: () => {
      const shown = report();
      return shown ? reportPdf.save(shown, host.endpointBase) : Promise.resolve({ success: false, error: SERVER_PDF_ERROR.general });
    },
    email: (to) => {
      sent = report() ?? null;
      return sent ? reportPdf.email(sent, to, host.endpointBase) : Promise.resolve({ success: false, error: SERVER_PDF_ERROR.general });
    },
    afterSent: async (to) => {
      await appStorage.local().setItem(AppStorageKey.reportPdfRecipient, to);
      await AuditLogService.info({ type: "email_report", email: to, report: sent ? reportPdf.document(sent).title : "" });
    }
  }, host);
}
export {
  useReportPdf
};
//# sourceMappingURL=index45.js.map
